import { Box, Typography, List, ListItem, ListItemIcon, ListItemText, Stack, Chip, useTheme, Divider } from '@mui/material';
import Iconify from 'src/components/iconify';

// ... (Trong component của bạn, đặt bên dưới Card/Typography Chú thích)

// Định nghĩa lại hàm getStatusColorBackground và getDiemSKColor ở đây nếu chúng không phải là global.
// Nếu chúng nằm trong component chính, bạn có thể gọi trực tiếp.

export const ChuthichSection = () => {
    const theme = useTheme();

    // Định nghĩa lại các hàm màu (chỉ dùng cho mục đích hiển thị trong Chú thích)

    const getStatusColorBackground = (status: number) => {
        switch (status) {
            case 1:
                return theme.palette.success.main;
            case 2:
                return theme.palette.blue[200];
            case 3:
                return theme.palette.error.main;
            default:
                return theme.palette.grey[50];
        }
    };
    const getDiemSKColor = (trangThaiId: number) => {
        switch (trangThaiId) {
            case 5:
                return theme.palette.success.darker; // Rất tốt
            case 4:
                return theme.palette.success.main; // Khá tốt
            case 3:
                return theme.palette.success.light; // Trung Bình
            case 2:
                return theme.palette.error.light; // Yếu
            case 1:
                return theme.palette.error.main; // Rất yếu 
            default:
                return theme.palette.grey[500]; // Màu xám cho mặc định
        }
    };

    return (
        <List dense sx={{ width: '100%' }}>
            <Typography variant="subtitle2" sx={{ mt: 1, mb: 1.5, ml: 2, color: 'text.secondary' }}>
                Tình trạng của cây sâm (Màu nền)
            </Typography>

            {/* Chú thích Màu nền (Status Background) */}
            <Stack direction="row" spacing={3} sx={{ ml: 2, mb: 2 }}>
                <Chip
                    label="Sống"
                    size="small"
                    sx={{ backgroundColor: getStatusColorBackground(1) }}
                />
                <Chip
                    label="Ngủ đông"
                    size="small"
                    sx={{ backgroundColor: getStatusColorBackground(2) }}
                />
                <Chip
                    label="Chết"
                    size="small"
                    sx={{ backgroundColor: getStatusColorBackground(3) }}
                />
            </Stack>

            <Divider sx={{ mb: 1 }} />

            <Typography variant="subtitle2" sx={{ mt: 1, mb: 1.5, ml: 2, color: 'text.secondary' }}>
                Icon góc phải
            </Typography>

            {/* Chú thích Icons */}
            <ListItem>
                <ListItemIcon sx={{ minWidth: 32 }}>
                    <Iconify icon="solar:check-circle-bold" width={16} sx={{ color: 'success.main' }} />
                </ListItemIcon>
                <ListItemText primary="Đã cập nhật Nhật ký tháng này" />
            </ListItem>
            <ListItem>
                <ListItemIcon sx={{ minWidth: 32 }}>
                    <Iconify icon="mingcute:nfc-fill" width={16} sx={{ color: 'warning.main' }} />
                </ListItemIcon>
                <ListItemText primary="Đã xác thực NFC" />
            </ListItem>

            <Divider sx={{ mt: 1, mb: 1 }} />

            <Typography variant="subtitle2" sx={{ mt: 1, mb: 1.5, ml: 2, color: 'text.secondary' }}>
                Điểm sức khỏe của cây sâm
            </Typography>

            {/* Chú thích Điểm sức khỏe */}
            <Stack direction="row" flexWrap="wrap" spacing={1} sx={{ ml: 2 }}>
                <Chip label="Rất tốt" size="small" sx={{ color: getDiemSKColor(5), borderColor: getDiemSKColor(5) }} variant="outlined" />
                <Chip label="Khá tốt" size="small" sx={{ color: getDiemSKColor(4), borderColor: getDiemSKColor(4) }} variant="outlined" />
                <Chip label="Trung Bình" size="small" sx={{ color: getDiemSKColor(3), borderColor: getDiemSKColor(3) }} variant="outlined" />
                <Chip label="Yếu" size="small" sx={{ color: getDiemSKColor(2), borderColor: getDiemSKColor(2) }} variant="outlined" />
                <Chip label="Rất yếu" size="small" sx={{ color: getDiemSKColor(1), borderColor: getDiemSKColor(1) }} variant="outlined" />
            </Stack>
        </List>
    );
};